export default function _setSceneApi(scene) {
  scene.getObject = title => {
    return scene.getObjectByProperty("title", title);
  };

  // Game 내부로부터 리액트 단으로 이벤트를 전달하기 위해 임시로 정의함
  // 추후 다른 범주로 교체하거나 로직 변경 필요
  scene.sendGameEvent = (type, value) => {
    this.context.dispatchFromGameEvent(type, value);
  };
}
